export default ()=> {
  // polyfillのため
  Object.assign({}, {});
  [].find(()=> {});
}
